var map = {
	"./Brazil.json": 1816,
	"./Indonesia.json": 7572,
	"./Malaysia.json": 1213,
	"./Singapore.json": 6564,
	"./Thailand.json": 6877,
	"./en.json": 517,
	"./zh-Hans.json": 6327
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5831;